import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from '@src/components/header';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';
import { callApp } from '@ifeng-fe/callapp';
import { getQuery } from '@src/common/utils';

const Layout = ({ content }) => {
    const { isPc } = getQuery();
    const { pageData } = content;

    const handleClick = () => {
        let kind = 'inter|sf_open04';
        let download = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210901901516924928';
        let downloadAd = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9127';

        if (isPc) {
            kind = 'inter_webdl01';
            download = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7210901594426762240';
            downloadAd = 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9126';
        }
        callApp({
            docType: 'web',
            pid: `https://ishare.ifeng.com/loc/webdaoliu/vip?package_name=com.ifeng.news2&isPc=${isPc}`,
            kind,
            noKindFrom: 1,
            download,
            downloadAd,
        });
    };

    return (
        <div className={styles.layout}>
            <Header />
            <p className={styles.subtitle}>打开APP即可获得VIP特权</p>
            <div className={styles.viptitle} />
            <div className={styles.box} />
            <div className={styles.tips}>
                <p>新用户下载APP后，再次扫描活动二维码点击打开App按钮即可获得</p>
                <p>已有APP用户点击下方按钮打开APP即可领取</p>
                <p>一个手机号仅能领取一次</p>
            </div>
            <div className={styles.btn} onClick={handleClick} />
            {pageData ? (
                <QQShare
                    content={{
                        title: pageData.shareTitle,
                        img: pageData.shareImgUrl,
                        desc: pageData.shareDesc,
                        url: pageData.shareUrl,
                        cb: () => {
                            console.log('分享成功');
                        },
                    }}
                />
            ) : null}
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
